var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5C5.82812 11.5 6.5 12.1719 6.5 13V13.5L8.76562 11.8C9.025 11.6062 9.34062 11.5 9.66562 11.5H14C14.275 11.5 14.5 11.275 14.5 11V2C14.5 1.725 14.275 1.5 14 1.5H2C1.725 1.5 1.5 1.725 1.5 2V11C1.5 11.275 1.725 11.5 2 11.5H5ZM6.5 15.375L6.49375 15.3813L6.33437 15.5L5.8 15.9C5.65 16.0125 5.44688 16.0312 5.275 15.9469C5.10313 15.8625 5 15.6906 5 15.5V14.8344V14.6344V14.625V14.5V13H3.5H2C0.896875 13 0 12.1031 0 11V2C0 0.896875 0.896875 0 2 0H14C15.1031 0 16 0.896875 16 2V11C16 12.1031 15.1031 13 14 13H9.66562L6.5 15.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBox);
export default __webpack_public_path__ + "static/media/text-box.60ae045a409c0196c8fdd431148779dd.svg";
export { ForwardRef as ReactComponent };